import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import z from "zod";
import { createPortfolioAndProgramSchema } from "@backend/src/schemas/projectSchema";
type CreatePortfolioProgramResponseType = ResponseType<{
  message:string
}>;

function useCreatePortfolioProgramMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<CreatePortfolioProgramResponseType>["response"],
    AxiosResponseAndError<CreatePortfolioProgramResponseType>["error"],
    z.infer<typeof createPortfolioAndProgramSchema>
  >({
    mutationFn: (data) =>
      ApiRequest.post<CreatePortfolioProgramResponseType>(
        `${requestURLs.project}/create-portfolio-program`,
        data
      ),
  });

  return mutation;
}

export default useCreatePortfolioProgramMutation;
